import React, { Fragment } from "react";
import logo from "../../../assets/images/share-registrar.svg";

const UserPanel = () => {
  const layoutWrapper = localStorage.getItem("wrapper");

  return (
    <Fragment>
      <div style={{
        backgroundColor: "transparent"
      }} className="sidebar-user text-center">
        <div>
          <img
            src={logo}
            alt=""
            className=""
            width={layoutWrapper === "compact-wrapper" ? "120" : "220"}
          />
          {/* <img
            className="img-60 rounded-circle lazyloaded blur-up"
            src={url ? url : man}
            alt="#"
          /> */}
          <div className="profile-edit">
            {/* <Link to={`/users/userEdit`}>
              <Edit />
            </Link> */}
          </div>
        </div>
        {/* <h6 className="mt-3 f-14">{sessionStorage.getItem("name")}</h6>
        <p>{sessionStorage.getItem("role")}</p> */}
      </div>
    </Fragment>
  );
};

export default UserPanel;
